import ak_logo from "../media/ak-logo.png";
import ak_total_product from "../media/total-product.png";
import ak_total_delivered from "../media/total-delivered.png";
import ak_gross_earning from "../media/gross-earning.png";
import ak_new_order from "../media/new-orders.png";
import cancelled_items from "../media/cancelled_items.png";
import returned_items from "../media/returned_items.png";
import dashboardcard_bg from "../media/d_bg.svg";
import Default from "../media/default.jpg";

const media = {
    ak_logo,
    ak_new_order,
    cancelled_items,
    returned_items,
    ak_total_product,
    ak_total_delivered,
    ak_gross_earning,
    dashboardcard_bg,
    Default,
};
export default media;